import { pars } from '@/config/net.config'
export default function parfn(par = [{}]) {
  console.log(par, 15441)
  let r = pars.find(function (f) {
    return par[0].par == f.value
  })
  return r ? r : { par: par[0].par }
}
